import { createSelector } from '@reduxjs/toolkit'

export const selectLocale = createSelector(
  (state) => state.locale,
  (locale) => {
    return locale.strings
  }
)
